var map = {
	"./dark.png": 7561,
	"./dragon.png": 4716,
	"./electric.png": 1684,
	"./esper.png": 6848,
	"./fairy.png": 7970,
	"./fight.png": 3911,
	"./flame.png": 556,
	"./fly.png": 7650,
	"./ghost.png": 4912,
	"./grass.png": 2091,
	"./ground.png": 4812,
	"./ice.png": 7600,
	"./insect.png": 7125,
	"./iron.png": 2031,
	"./normal.png": 88,
	"./poison.png": 9381,
	"./psychic.png": 5936,
	"./rock.png": 5754,
	"./undefined.png": 5073,
	"./unknown.png": 8467,
	"./water.png": 6612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7190;